import { PUBLIC_ORIGIN } from '../../app-config.js';

// A native WebView's origin is https://localhost, so a relative /api resolves
// into the app bundle and answers with the page rather than the route — which
// reads, to the person holding the phone, as "the server did not answer
// properly". The server is elsewhere, and PUBLIC_ORIGIN is where.
export const apiBase = () => (globalThis.Capacitor?.isNativePlatform?.() ? PUBLIC_ORIGIN : '');
